import { ArrowNarrowLeftIcon, ChevronRightIcon } from "@heroicons/react/solid";
import BigNumber from "bignumber.js";
import { useEffect, useRef, useState } from "react";
import { usePopWindow } from "../components/BottomPopWindow";
import { CoinPanel, ErrorBar, FormInput, InformationBar, LoadingDialog, WalletAccount_Pop_List } from "../components/CommonComponents";
import Button from "../components/control/Button";
import { ListSelector } from "../components/ListSelector";
import { Icon_History, Icon_USER_CIRCLE, LoadingCircleSVG } from "../components/Svgs";
import { ToastType, useToast } from "../components/Toast";
import API from "../conf/API";
import { WAIdToName, WalletAccount } from "../conf/Config";
import { AddressBookView, PopWnd_AddressBook } from "../modules/AddressBook";
import DataCenter, { Calculator, CurrentCurrency, QuoteCoinID, TransactionMethod } from "../modules/DataCenter";
import { Localize, LocalStr } from "../modules/localize/Localize";
import { WalletService, WalletTxInfo } from "../modules/WalletService";
import { Events, JSEvent } from "../utils/JSEvent";
import { post } from "../utils/request";
import { addressEquals } from "../utils/Utils";
import { TransactionHistory_View } from "./TransactionOrderView";

export const WithdrawView = ({ addView, fireViewAction, walletAccount, mode = TransactionMethod.Withdraw }) => {
    const coinPanels = [];
    if (DataCenter.hasSymbolData()) {
        const coins = DataCenter.getCoins();
        const l = coins.length;

        const wallet = mode == TransactionMethod.Withdraw ? walletAccount : WalletAccount.DeFi;
        const hideFrozen = true;

        for (let i = 0; i < l; i++) {
            const coin = coins[i];
            coinPanels.push(<CoinPanel coin={coin} key={coin.id} wallet={wallet} hideFrozen={hideFrozen} includeFrozen={false} onClick={
                ({ coin, wallet }) => {
                    addView(WithdrawView_Send, "left", null, action => { },
                        {
                            addView: addView,
                            coin: coin,
                            walletAccount: walletAccount,
                            mode: mode
                        })
                }
            } />);
            if (i < l - 1)
                coinPanels.push(<div className='w-full h-[1px] bg-gray-100' key={coin.id + 100000000} />)
        }
    }


    return <div className="flex flex-col w-full h-full bg-white p-4">
        <div className=' w-full h-8 flex flex-row items-center justify-center' onClick={() => fireViewAction({ name: "close" })}>
            <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" />
            <div className="flex flex-1 font-semibold justify-center items-center pr-6">
                {Localize.getMsg(Localize.UI.WithdrawView[mode == TransactionMethod.Withdraw ? 'title' : 'title_send'])}
            </div>
        </div>
        <LocalStr msg={Localize.COMMON.coinList} className="pt-2 font-semibold" />
        {coinPanels}
    </div>
}

const WithdrawView_Pop_Review = ({ onViewAction, txInfo }) => {
    const coin = DataCenter.getCoin(txInfo.coinType);
    const quoteCoin = DataCenter.getCoin(QuoteCoinID);
    const currency = CurrentCurrency();
    const price = DataCenter.getCoinQuotePrice(coin.id, quoteCoin.id, currency.name);

    let tip = "";
    if (addressEquals(txInfo.txFrom, txInfo.txTo)) {
        tip = Localize.getMsg(Localize.UI.WithdrawView.sameAddress);
    }

    let txTo = txInfo.getTxTo();
    if (txTo == WalletService.address()) {
        txTo = WAIdToName(WalletAccount.DeFi);
    }

    return <>
        <LocalStr msg={Localize.Order.willReceive} className="text-gray-400 text-sm flex justify-center" />
        <div className="text-2xl font-semibold flex justify-center text-black pt-1">
            {txInfo.getAmount().toTrimed(2, coin.showDecimals)} {coin.name}
        </div>
        <div className="text-gray-400 text-xs flex justify-center">
            ≈ {currency.symbol}{price.times(txInfo.getAmount()).toTrimed(currency.decimals, currency.decimals)}
        </div>

        {
            tip == "" ? null :
                <ErrorBar text={tip} />
        }

        <div className="bg-gray-100 w-full  flex flex-col p-3 text-gray-500 rounded-md mt-3">
            <div className="flex w-full">
                <LocalStr msg={Localize.COMMON.recvAddress} className="flex-1 flex items-center" />
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{txTo}</div>
            </div>
            <div className="flex w-full pt-2">
                <LocalStr msg={Localize.COMMON.transferNet} className="flex-1 flex items-center" />
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{WalletService.blockchain.text}</div>
            </div>
            <div className="flex w-full pt-2">
                <LocalStr msg={Localize.Order.sendFrom} className="flex-1 flex items-center" />
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{WAIdToName(txInfo.walletAccount)}</div>
            </div>
            <div className="w-full h-[1px] bg-gray-200 my-4"></div>
            <div className="flex w-full">
                <LocalStr msg={Localize.Order.sendCoin} className="flex-1 flex items-center" />
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{coin.name}</div>
            </div>
            <div className="flex w-full pt-2">
                <LocalStr msg={Localize.Order.totalAmount} className="flex-1 flex items-center" />
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{txInfo.getAmount(false).toTrimed(2, coin.showDecimals)} {coin.name}</div>
            </div>
            <div className="flex w-full pt-2">
                <LocalStr msg={Localize.COMMON.serviceFee} className="flex-1 flex items-center" />
                <div className="text-sm w-[60%] font-semibold break-words text-right text-black">{txInfo.getGasFee()} {quoteCoin.name}</div>
            </div>
        </div>
        <div className="flex w-full">
            <InformationBar text="L:Order.transferTip" />
        </div>

        <div className="flex w-full pt-3">
            <Button type="primary" name="L:COMMON.Confirm" widthStyle="w-full" padding="py-2" className="font-semibold text-lg"
                onClicked={e => {
                    onViewAction("ok")
                    onViewAction("close")
                }} />
        </div>
    </>
}

const WithdrawView_Send = ({ addView, fireViewAction, coin, walletAccount, clearView, mode }) => {
    const [selAddr, setSelAddr] = useState(null);
    const [transferNet, setTransferNet] = useState(WalletService.blockchain);
    const [addrTo, setAddrTo] = useState("");
    const [sendAmount, setSendAmount] = useState("");
    const [sendEnable, setSendEnable] = useState(false);
    const [calc, setCalc] = useState(false);
    const [txInfo, setTxInfo] = useState(null);
    const [sendAcc, setSendAcc] = useState(walletAccount)
    const [accAvailable, setAccAvailable] = useState({})
    const [errMsg, setErrMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const [pop] = usePopWindow();
    const [makeToast] = useToast();

    const quoteCoin = DataCenter.getCoin(QuoteCoinID);

    const calcSend = (coin, sendAmount) => {
        setCalc(true);
        const amount = Calculator.toBigNumber(sendAmount, coin.id)
        const body = {
            coinType: coin.id,
            walletAccount: sendAcc,
            txMethod: mode,
            transferNet: transferNet.key,
            amount: amount.toFixed(),
            txFrom: sendAcc == WalletAccount.DeFi ? WalletService.address().toString() : "",
            txTo: addrTo,
            signer: "",
        }
        post(API.wallet_trans_fee(), body).then(async ret => {
            if (ret.error) {
                console.log(ret);
            } else {
                const ti = new WalletTxInfo(ret.retObject);
                setTxInfo(ti);
                ti.gasPrice = new BigNumber(ti.gasPrice);
                ti.gasUsed = new BigNumber(ti.gasUsed);
                // ti.getGasFee = () => {
                //     // const p = ti.gasPrice.times(ti.gasUsed);
                //     // const p1 = Calculator.toNumber(p, QuoteCoinID).toTrimed(2, quoteCoin.showDecimals);
                //     // return p1;
                //     return WalletService.provider.calcGasFee(ti.gasPrice, ti.gasUsed, quoteCoin).str;
                // }
                // ti.getAmount = (excludeGasFee = true) => {
                //     const g = new BigNumber(ti.getGasFee());
                //     const a = Calculator.toNumber(ti.amount, coin.id)
                //     return excludeGasFee && ti.coinType == QuoteCoinID ? a.minus(g) : a;
                // }
                // ti.getTxFrom = () => {
                //     if (WalletService.isDeFiWalletAddr(ti.txFrom)) {
                //         return "DeFi钱包"
                //     }
                //     return ti.txFrom;
                // }
                // ti.getTxTo = () => {
                //     if (WalletService.isDeFiWalletAddr(ti.txTo)) {
                //         return "DeFi钱包"
                //     }
                //     return ti.txTo;
                // }

                //检查账户中是否有足够的QuoteCoin支付手续费
                const gasFee = WalletService.provider.calcGasFee(ti.gasPrice, ti.gasUsed, quoteCoin).bn;
                const amount = ti.getAmount(false);
                let balance = null;
                if (sendAcc == WalletAccount.DeFi) {
                    //从DeFi钱包中发送，检查钱包中的余额
                    balance = await WalletService.walletInfo.balance(quoteCoin);
                } else {
                    //从MetaVirus账户中发送，检查对应的钱包账户
                    balance = DataCenter.walletBalance(sendAcc, quoteCoin.id);
                }
                if (gasFee.isGreaterThan(balance)) {
                    setSendEnable(false);
                    setErrMsg(Localize.getMsg(
                        Localize.Msg.Trade_NotEnoughCoin,
                        WAIdToName(sendAcc),
                        quoteCoin.name,
                        ti.getGasFee() + " " + quoteCoin.name
                    ))
                } else if (coin.id == QuoteCoinID && gasFee.isGreaterThan(amount)) {
                    setSendEnable(false);
                    setErrMsg(Localize.getMsg(
                        Localize.Msg.Trade_AmountTooSmall,
                        ti.getGasFee() + " " + quoteCoin.name
                    ))
                } else {
                    setErrMsg("");
                    setSendEnable(true);
                }
            }
            setCalc(false);
        })
    }

    useEffect(() => {
        const valid = addrTo != "" && sendAmount != "" && sendAmount.isGreaterThan(0);
        if (valid && !calc) {
            calcSend(coin, sendAmount);
        }
    }, [addrTo, sendAmount])

    useEffect(() => {
        inputSend.current.validateInput();
    }, [sendAcc])

    useEffect(() => {
        const { walletInfo } = WalletService;

        const available = {
            [WalletAccount.TradeAccount]: DataCenter.walletBalance(WalletAccount.TradeAccount, coin.id, false),
            [WalletAccount.GameAccount]: DataCenter.walletBalance(WalletAccount.GameAccount, coin.id, false),
        }

        if (walletInfo != null) {
            walletInfo.balance(coin).then(
                ret => {
                    available[WalletAccount.DeFi] = ret;
                    setAccAvailable(available);
                }
            );
        } else {
            setAccAvailable(available);
        }
    }, [])

    const total = accAvailable[sendAcc];

    const inputSend = useRef();
    const inputAddr = useRef();

    return <div className="flex flex-col w-full h-full bg-white ">
        <div className="flex flex-col w-full h-full bg-white p-4">
            <div className=' w-full h-8 flex flex-row items-center justify-center'>
                <ArrowNarrowLeftIcon className="h-6 text-gray-500" aria-hidden="true" onClick={() => fireViewAction({ name: "close" })} />
                <div className="flex flex-1 font-semibold justify-center items-center pl-8 text-xl" onClick={() => fireViewAction({ name: "close" })}>
                    {Localize.getMsg(mode == TransactionMethod.Withdraw ? Localize.COMMON.Withdraw : Localize.COMMON.Send)}
                    &nbsp;
                    {coin.name}</div>
                <div className="flex" onClick={e => {
                    addView(TransactionHistory_View, "left", null, action => {

                    }, { addView: addView, openTabType: mode })
                }}><Icon_History className="w-14 h-6 px-4" /></div>
            </div>
            <div className="flex flex-col w-full pt-4 flex-1">
                <LocalStr msg={Localize.COMMON.recvAddress} className="text-gray-500 text-sm" />
                <div className="flex rounded-md mt-1 text-xs ">
                    <FormInput ref={inputAddr} placeholder={Localize.getMsg(Localize.UI.WithdrawView.recvAddressTip)}
                        onReset={e => {
                            setAddrTo("")
                            setTxInfo(null);
                        }}
                        suffix={<div className="flex text-gray-500 px-1 py-2 justify-center items-center text-base">
                            <Icon_USER_CIRCLE className="w-5 h-5" onClick={e => {
                                pop("pop_addressbook", PopWnd_AddressBook,
                                    Localize.getMsg(Localize.COMMON.walletAddress)
                                    , action => {
                                        console.log(action)
                                        switch (action.name) {
                                            case "newAddress":
                                                addView(AddressBookView, "left", null, act => {
                                                })
                                                break;
                                            case "selAddress":
                                                if (action.value == null) return;
                                                setSelAddr(action.value);
                                                inputAddr.current.setValue(action.value.address);
                                                setAddrTo(action.value.address);
                                                break;
                                        }
                                    }, { selAddr: selAddr, coinType: coin.id, transferNet: transferNet.key });
                            }} />
                        </div>}
                        validInput={(name, value) => {
                            if (!WalletService.provider.isValidAddress(value)) {
                                setAddrTo("");
                                setTxInfo(null);
                                return Localize.getMsg(Localize.UI.WithdrawView.checkAddressTip);
                            }
                            setAddrTo(value);
                        }}
                    />


                </div>

                <LocalStr msg={Localize.COMMON.transferNet} className="text-gray-500 text-sm pt-4" />
                <div className=" bg-gray-100 px-3 py-2 rounded-md mt-1">
                    {transferNet.text}
                </div>

                <div className="text-gray-500 text-sm pt-4">{
                    Localize.getMsg(mode == TransactionMethod.Withdraw ? Localize.COMMON.withdrawAmount
                        : Localize.COMMON.sendAmount)}</div>
                <div className="flex rounded-md mt-1  items-center">
                    <div className="flex flex-1">
                        <FormInput ref={inputSend} type="number"
                            onReset={e => {
                                setSendAmount("");
                                setTxInfo(null);
                            }}
                            suffix={<div className="flex">
                                <div className="text-gray-400 pr-1">{coin.name}</div>
                                <div className="text-link flex pr-3 text-sm items-center" onClick={e => {
                                    if (inputSend.current) {
                                        inputSend.current.setValue(total.toTrimed(2));
                                    }
                                }}>{Localize.getMsg(Localize.COMMON.sendTotal)}</div>
                            </div>}
                            validInput={(name, value) => {
                                if (value == "") return;
                                const v = new BigNumber(value);
                                if (v.isGreaterThan(total)) {
                                    setSendAmount("")
                                    setTxInfo(null);
                                    return Localize.getMsg(Localize.COMMON.notEnoughBalance);
                                }
                                setSendAmount(v)
                            }} />
                    </div>

                </div>


                <LocalStr msg={Localize.COMMON.SendAccount} className="text-gray-500 text-sm pt-4" />
                <div className="text-gray-600 text-base bg-gray-100 px-3 py-2 rounded-md flex" onClick={e => {
                    if (mode == TransactionMethod.Withdraw) {
                        pop("pop_list_walletaccount", WalletAccount_Pop_List,
                            Localize.getMsg(Localize.COMMON.SelSendAccount), action => {
                                if (action.name == "select") {
                                    const item = action.value;
                                    setSendAcc(item.id);
                                }
                            }, { walletAccount: sendAcc, coin: coin, includeDeFi: false });
                    }
                }}>
                    <div className="font-semibold flex-1">{WAIdToName(sendAcc)} - {Localize.getMsg(Localize.COMMON.Balance)} {accAvailable[sendAcc] == null ? "" : accAvailable[sendAcc].toTrimed(2)} {coin.name}</div>

                    {
                        mode == TransactionMethod.Withdraw ?
                            <div className="w-6 h-6"><ChevronRightIcon className="w-6 h-6" /></div> : null
                    }
                </div>

                {
                    errMsg == "" || errMsg == null ? null : <ErrorBar text={errMsg} />
                }

                {/*<div className="flex text-gray-600 text-sm pt-4 font-semibold">
                    <div className="flex-1">可用</div>
                    <div className="pr-3">{total.toTrimed(2)} {coin.name}</div>
                </div>
                 <div className="flex flex-col text-sm text-gray-500 bg-gray-100 px-3 py-2 rounded-md mt-1">
                    <div className="flex">
                        <div className="flex-1">{WalletAccountName[WalletAccount.TradeAccount]}</div>
                        <div className="">{available[WalletAccount.TradeAccount].toTrimed(2, coin.showDecimals)} {coin.name}</div>
                    </div>
                    <div className="flex pt-2">
                        <div className="flex-1">{WalletAccountName[WalletAccount.GameAccount]}</div>
                        <div className="">{available[WalletAccount.GameAccount].toTrimed(2, coin.showDecimals)} {coin.name}</div>
                    </div>
                </div> */}
            </div>
        </div>
        <div className="h-[1px] bg-gray-100 w-full"></div>
        <div className="flex p-4 pb-8 w-full">
            <div className="flex flex-col flex-1 bg-white">
                <LocalStr msg={Localize.COMMON.sendAmount} className="text-sm text-gray-500" />
                <div className="flex items-end">
                    {calc ? <div className="text-link w-6 h-6">{LoadingCircleSVG}</div> : null}
                    <div className="text-xl font-semibold">{txInfo == null || txInfo.getAmount == null ? "0.00" : txInfo.getAmount().toTrimed(2)}</div>
                    <div className="font-semibold pl-1">{coin.name}</div>
                </div>
                <div className="text-sm text-gray-500">{Localize.getMsg(Localize.COMMON.serviceFee)} {txInfo == null || txInfo.getGasFee == null ? "0.00" : txInfo.getGasFee()} {quoteCoin.name}</div>
            </div>
            <div className="flex flex-col items-center justify-center">
                <Button name="L:COMMON.Send" type="primary" padding="py-2" disabled={!sendEnable || txInfo == null}
                    onClicked={e => {
                        txInfo.walletAccount = sendAcc;
                        pop("pop_send_review", WithdrawView_Pop_Review,
                            Localize.getMsg(Localize.Order.confirm), action => {
                                if (action.name == "ok") {
                                    setLoading(true);
                                    if (mode == TransactionMethod.Withdraw) {
                                        //提现模式
                                        post(API.wallet_trans_do(), txInfo.requestBody()).then(async ret => {
                                            if (ret.error) {
                                                makeToast(Localize.getCodeMsg("DefiWallet", ret.code),
                                                    ToastType.wrong, "topup_submitted_error");
                                                setLoading(false);
                                                return;
                                            }
                                            try {
                                                makeToast(Localize.getMsg(Localize.UI.TopupView.order_submitted),
                                                    ToastType.right);
                                                setLoading(false);
                                            } catch (e) {
                                                console.error(e);
                                            }
                                            clearView();
                                            const txInfo1 = new WalletTxInfo(ret.retObject);
                                            JSEvent.emit(Events.Wallet.PenddingTransaction, { token: coin, walletTxInfo: txInfo1 })
                                        })
                                    } else if (mode == TransactionMethod.Transfer) {
                                        //DeFi转账模式
                                        WalletService.provider.transfer(txInfo).then(sign => {
                                            post(API.wallet_trans_do(), txInfo.requestBody()).then(async ret => {
                                                console.log("wallet_trans_do.result:", ret)
                                                if (ret.error) {
                                                    makeToast(Localize.getCodeMsg("DefiWallet", ret.code),
                                                        ToastType.wrong, "topup_submitted_error");
                                                    setLoading(false);
                                                    return;
                                                }
                                                try {
                                                    makeToast(Localize.getMsg(Localize.UI.TopupView.order_submitted),
                                                        ToastType.right);
                                                    setLoading(false);
                                                } catch (e) {
                                                    console.error(e);
                                                }
                                                clearView();
                                            })
                                        });

                                    }
                                }
                            }, { txInfo })
                    }} />
            </div>
        </div>
        <LoadingDialog show={loading} />
    </div>
}

